import React from 'react';
import clsx from 'classnames';
import './index.css';

const Laboratory = () => {
  const laboratoryList = [
    {
      name: '机械实验室',
      img: '/images/laboratory1.png',
    },
    {
      name: '电气实验室',
      img: '/images/laboratory2.png',
    },
    {
      name: '材料实验室',
      img: '/images/laboratory3.png',
    },
    {
      name: '工器具实验室',
      img: '/images/laboratory4.png',
    },
    {
      name: '高压实验室',
      img: '/images/laboratory5.png',
    },
    {
      name: '环境实验室',
      img: '/images/laboratory6.png',
    },
    {
      name: '理化实验室',
      img: '/images/laboratory7.png',
    },
    {
      name: '高处防坠落实验场',
      img: '/images/laboratory8.png',
    },
    {
      name: '中央控制室',
      img: '/images/laboratory9.png',
    },
  ];

  return (
    <div className={clsx('business-laboratory')}>
      <div className={clsx('business-laboratory-title')}>专业实验室</div>
      <div className={clsx('business-laboratory-desc')}>
        多类型实验室，贴合检测需求
      </div>
      <div className={clsx('business-laboratory-content')}>
        {laboratoryList.map((item, index) => (
          <div className={clsx('business-laboratory-content-item')} key={index}>
            <div className={clsx('business-laboratory-content-item-img')}>
              <img src={item.img} alt={item.name} />
            </div>
            <div className={clsx('business-laboratory-content-item-name')}>
              {item.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Laboratory;
